<div class="container">
  <div class="rounded">
    <i class="wi wi-thermometer icon"></i>
  </div>
  <div class="temp">
    <h1 style="margin-bottom: 0; font-size: x-large; font-weight: bold;">{{temp}} °F</h1>
  </div>
</div>